let inMemoryToken: string | null = null;

export const tokenManager = {
  setToken: (token: string | null) => {
    inMemoryToken = token;
    if (token) {
      sessionStorage.setItem("auth_token", token);
    } else {
      sessionStorage.removeItem("auth_token");
    }
  },

  getToken: (): string | null => {
    if (inMemoryToken) {
      return inMemoryToken;
    }
    const token = sessionStorage.getItem("auth_token");
    if (token) {
      inMemoryToken = token;
    }
    return inMemoryToken;
  },

  clearToken: () => {
    inMemoryToken = null;
    sessionStorage.removeItem("auth_token");
  },
};
